import { RouterModule, Routes } from '@angular/router';
import { samlSsoRoute } from '@ats/auth-components';
import { AuthGuard } from '@auth0/auth0-angular';
import { AuthErrorComponent } from './components/auth-error/auth-error.component';
import { ResourceLinkComponent } from './components/resource-link/resource-link.component';

const routes: Routes = [
  samlSsoRoute,
  {
    path: 'go/task/:id',
    component: ResourceLinkComponent,
    canActivate: [AuthGuard],
    data: {
      resourceType: 'task'
    }
  },
  {
    path: 'go/req/:id',
    component: ResourceLinkComponent,
    canActivate: [AuthGuard],
    data: {
      resourceType: 'req'
    }
  },
  {
    path: 'part/:id/:panel',
    redirectTo: 'parts/:id/:panel',
    pathMatch: 'full'
  },
  {
    path: 'part/:id',
    redirectTo: 'parts/:id',
    pathMatch: 'full'
  },
  {
    path: 'part',
    redirectTo: 'parts',
    pathMatch: 'full'
  },
  {
    path: 'parts',
    loadChildren: () => import('./containers/part/part.module').then((m) => m.PartModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'stock',
    loadChildren: () => import('./containers/stock/stock.module').then((m) => m.StockModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'translogs',
    loadChildren: () =>
      import('./containers/translogs/translogs.module').then((m) => m.TranslogsModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'bins',
    loadChildren: () => import('./containers/bins/bins.module').then((m) => m.BinsModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'requisitions',
    loadChildren: () =>
      import('./containers/requisitions/requisitions.module').then((m) => m.RequisitionsModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'requests',
    loadChildren: () =>
      import('./containers/requests/requests.module').then((m) => m.RequestsModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'miscellaneous-transactions',
    loadChildren: () =>
      import('./containers/miscellaneous-transactions/miscellaneous-transactions.module').then(
        (m) => m.MiscellaneousTransactionsModule
      ),
    canActivate: [AuthGuard]
  },
  {
    path: 'auth_error',
    component: AuthErrorComponent
  },
  { path: '**', redirectTo: 'parts', pathMatch: 'full' }
];

export const appRouting = RouterModule.forRoot(routes);
